import { toast } from "react-toastify";

const showError = (message) => customToast(message, toast.error);
const showSuccess = (message) => customToast(message, toast.success);

const customToast = (message, toaster) => {
  console.log("message?.message", message);
  if (message?.message) {
    toaster(message.message);
  }
  if (Array.isArray(message) && message.length > 0) {
      console.log("message error", message);
      let msg="";
      message.forEach((mg,idx)=>{
        if(message.length === 1){
          msg+=mg; 
        }
        if(mg && idx>=1 ){
          msg+=mg; 
        }
      })

    toaster(msg);

  }
  if (message) {
    toaster(message);
  }
};

export const ToastifyService = {
  showError,
  showSuccess,
};
